export const radiusOptions = [{
    id: 0,
    name: '',
}, {
    id: 5,
    name: '5m/15ft',
}, {
    id: 10,
    name: '10m/32ft',
}, {
    id: 15,
    name: '15m/50ft',
}, {
    id: 25,
    name: '25m/82ft'
}, {
    id: 30,
    name: '30m/100ft',
}, {
    id: 50,
    name: '50m/165ft',
}, {
    id: 100,
    name: '100m/330ft'
}, {
    id: 1000,
    name: '1km/0.6mi'
}]

export const radiusOptionsNoUnits = [{
    id: 0,
    name: '',
}, {
    id: 5,
    name: '5',
}, {
    id: 10,
    name: '10',
}, {
    id: 15,
    name: '15',
}, {
    id: 25,
    name: '25'
}, {
    id: 30,
    name: '30',
}, {
    id: 50,
    name: '50',
}, {
    id: 100,
    name: '100'
}, {
    id: 1000,
    name: '1000'
}]

export const getRadiusLabel = str => {
    const ftPerMeter = 3.281
    const kmPerMeter = 1/1000
    const milePerMeter = 1/1609
    const radius = Number(str)
    if (radius >= 1000) {
        return `${radius * kmPerMeter}km/${(radius * milePerMeter).toFixed(1)}mi`
    }
    return `${radius}m/${(radius * ftPerMeter).toFixed(0)}ft`
}